import axios from "axios";

// Use the SAME origin as the page being served, so all cookies stay first-party
// (mobile browsers — especially Safari iOS — block cross-site cookies, which
// would silently break login on profawz.fr if the API was on a different host).
// We only fall back to REACT_APP_BACKEND_URL during local dev / SSR where
// `window` is undefined.
const SAME_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
export const BACKEND_URL = SAME_ORIGIN || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
